import React from "react";
import ColorAndWheelPicker from "./ColorPicker";
import styled from "styled-components";
import SelectedHotspotDescription from "./SelectedHotspotDescription";
import useTransitionStore from "../../../state/transitions";
import { isMobile } from "react-device-detect";
import MobileModalDisclaimer from "./MobileModalDisclaimer";
import SuspensionUI from "./SuspensionUI";

const Customizer = () => {
  const DisplayMode = useTransitionStore((state) => state.DisplayMode);
  const SuspensionMode = useTransitionStore((state) => state.SuspensionMode);

  return (
    <>
      {!isMobile && <SuspensionUI />}
      <MobileModalDisclaimer />
      <div
        className="ColorSelect"
        style={{
          zIndex: 999,
          position: "absolute",
          pointerEvents: "none",
          color: "#FFFCF9",
          width: "100%",
          height: "100%",
        }}
      >
        <SelectedHotspotDescription />
      </div>
      {DisplayMode !== "flipper" &&
        DisplayMode !== "powertrain" &&
        !SuspensionMode && <ColorAndWheelPicker />}
    </>
  );
};

const CustomizerContainer = styled.div`
  z-index: 1000;
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 10px;
  left: 16px;
  pointer-events: none;
`;

export default Customizer;
